import { CmsMenuTags } from '@redteclab/api/clients/content-management-system'
import classNames from 'classnames'
import type { VFC } from 'react'

import Item from 'views/components/organisms/CmsMobileMenu/Item'
import type {
  FeatureToggle,
  ItemListProps,
} from 'views/components/organisms/CmsMobileMenu/types'
import { shouldRenderErxAnnouncement } from 'views/components/organisms/Menubar/ErxTooltip/helpers'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import { isRedPointsActive } from 'views/utils/featureToggleUtils'

const ItemList: VFC<ItemListProps> = props => {
  const {
    canonicalUrl,
    goNextHandler,
    items,
    menu,
    name,
    publicRuntimeConfig,
    showCategoryTitle,
    className,
  } = props

  const featureToggles = publicRuntimeConfig?.pageProperties?.featureToggles
  const redPointsToggleIsActive = isRedPointsActive(
    featureToggles as FeatureToggle
  )
  // Don't allow multiple announcements be rendered
  let isAnnouncementFound = false

  const isGhostItem = menu.tags?.includes(CmsMenuTags.Highlighted)

  return (
    <ul className={classNames(className, 'a-list-reset')}>
      {showCategoryTitle && (
        <li>
          <Item href={canonicalUrl}>{name}</Item>
        </li>
      )}

      {items.map((item, index: number) => {
        const { href: itemCanonicalUrl, title: itemName, icon } = item

        const tags = item.tags ? [...item.tags] : []

        if (isGhostItem) {
          tags.push('ghost')
        }

        if (!redPointsToggleIsActive && itemName === 'RedPoints') {
          return null
        }

        const hasErxAnnouncement =
          !isAnnouncementFound && shouldRenderErxAnnouncement(itemCanonicalUrl)
        if (hasErxAnnouncement) {
          isAnnouncementFound = true
        }

        const itemProps = {
          goNextHandler,
          hasErxAnnouncement,
          href: itemCanonicalUrl,
          icon,
          name: itemName,
          tags,
        }

        return (
          <li
            key={index}
            data-clientside-hook={
              hasErxAnnouncement ? 'handle-erx-announcement' : null
            }
          >
            <Item {...itemProps}>{itemName}</Item>
          </li>
        )
      })}
    </ul>
  )
}

ItemList.defaultProps = {
  isTopLevel: false,
  showCategoryTitle: false,
}

export default withShopAndRuntimeConfig(ItemList)
